import { render, staticRenderFns } from "./VQuestionSubSection.vue?vue&type=template&id=0861cbbc&scoped=true&"
import script from "./VQuestionSubSection.vue?vue&type=script&lang=js&"
export * from "./VQuestionSubSection.vue?vue&type=script&lang=js&"
import style0 from "./VQuestionSubSection.vue?vue&type=style&index=0&id=0861cbbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0861cbbc",
  null
  
)

export default component.exports